import React, { memo } from 'react';
import styled from 'styled-components';
import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';
import { HourlyForecastCardsList } from '../../common/hourlyForecastCardsList';
import { largeHourlyForecastViewId } from '../../common/utils';
import { Next12Hours } from '../pagination/next12Hours';
interface LargeHourlyForecastViewProps {
    isMobile: boolean;
}

export const LargeHourlyForecastView = memo(withScreenSize(({ isMobile }: LargeHourlyForecastViewProps) => {
    if (isMobile) {
        return null;
    }
    return (
        <>
            <Container id={largeHourlyForecastViewId}>
                <HourlyForecastCardsList />
                <Next12Hours />
            </Container>
        </>
    );
}));

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
`;